import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";
import { personReportFilters } from "./personReportFilters";

let peopleTable;
const tableColumns = ["Email", "Roles", "Tags", "Editions", "Regions", "Areas", "Military", "Surgeon"];
let currentPage = 0;
const pageSize = 20;
let hasNextPage;
let dataSet = [];
let sort = {};

function init() {
    $("#btnApplyFilters").click(applyFilters);
    $("#btnDownloadExcel").click(function() {
        let source = $(this).attr("href");

        if (!source.endsWith("?")) {
            source += "?";
        }

        source += $.param(personReportFilters.getQueryStringFilters());

        $(this).attr("href", source);
    });
    $("#next").click(goNextPage);
    $("#previous").click(goPreviousPage);
    $(".sorting, .sorting_asc, .sorting_desc").click(applySort);
    getData().then(function(data) {
        buildDataSet(data);
        buildTable();
    });
}

function goNextPage() {
    if (!hasNextPage) return;
    currentPage++;
    applyFilters(personReportFilters.getFilters);
}
function goPreviousPage() {
    if (currentPage === 0) return;
    currentPage--;
    applyFilters(personReportFilters.getFilters);
}

function buildDataSet(data) {
    dataSet = [];
    if (!data || !data.length) { return; }
    for (let i = 0; i < data.length; i++) {
        dataSet.push([data[i].email, data[i].roles, data[i].tags, data[i].editions, data[i].regions, data[i].areas, data[i].military, data[i].surgeon]);
    }
    hasNextPage = data.length > pageSize;
    setNextPrevButtonEnabled();
}

function buildTable() {
    peopleTable = $("#peopleTable").DataTable({
        "serverSide": false, // for process server side
        "filter": false, // this is for disable filter (search box)
        //"orderMulti": false, // for disable multiple column at once
        "data": dataSet,
        "bLengthChange": false,
        "bPaginate": false,
        "PageLength": 20,
        "bInfo": false,
        "ordering": false,
        "columnDefs":
            [
                {
                    "targets": 0,
                    "name": "Email"
                },
                {
                    "targets": 1,
                    "name": "Role(s)"
                },
                {
                    "targets": 2,
                    "name": "Tag(s)"
                },
                {
                    "targets": 3,
                    "name": "Edition(s)"
                },
                {
                    "targets": 4,
                    "name": "Region(s)"
                },
                {
                    "targets": 5,
                    "name": "Area(s)"
                },
                {
                    "targets": 6,
                    "name": "Military?",
                    mRender: function(data, type, row) {
                        if (data === undefined) return "";
                        return data ? "Yes" : "No";
                    }
                },
                {
                    "targets": 7,
                    "name": "Surgeon",
                    mRender: function(data, type, row) {
                        if (data === undefined) return "";
                        return data ? "Yes" : "No";
                    }
                }
            ]
    });
}

function applyFilters() {
    getData().then(function(data) {
        buildDataSet(data);
        peopleTable.clear();
        peopleTable.rows.add(dataSet).draw();
        setNextPrevButtonEnabled();
    });
}

function applySort(e) {
    const asc = $(this).hasClass("sorting") || $(this).hasClass("sorting_desc");
    $(".sorting, .sorting_asc, .sorting_desc").removeClass()
        .addClass("sorting");

    if (asc) {
        $(this).removeClass("sorting").removeClass("sorting_desc").addClass("sorting_asc");
    } else {
        $(this).removeClass("sorting").removeClass("sorting_asc").addClass("sorting_desc");
    }
    $(".sorting, .sorting_asc, .sorting_desc").not($(this)).removeClass(".sorting_asc").removeClass(".sorting_desc")
        .addClass("sorting");
    sort = {
        column: tableColumns[peopleTable.column(this).index()],
        desc: $(this).hasClass("sorting_desc")
    };
    applyFilters();
}

function getData() {
    const filters = personReportFilters.getFilters();
    filters.desc = sort.desc;
    filters.sortColumn = sort.column || "";
    return dataaccess.post({ url: "/PersonReport/getPersonReport/" + currentPage, data: filters });
}

function setNextPrevButtonEnabled() {
    if (!hasNextPage) {
        $("#next").addClass("disabled");
    } else {
        $("#next").removeClass("disabled");
    }
    if (currentPage === 0) {
        $("#previous").addClass("disabled");
    } else {
        $("#previous").removeClass("disabled");
    }
}

export const personReport = {
    init: init
};